<template>
  <!--
   [class]
    1. 재생 전: play-container apollo-play-container
    2. 재생 중/일시정지: play-container apollo-play-container apollo-play-on
  -->
  <div class="play-container apollo-play-container" v-bind:class="{'apollo-play-on': isPlay}" v-if="isLoaded" :style="{'z-index':zIndex}">
    <div class="play-detail-container">
      <MobilePlayer
          :content-info="contentInfo"
          :current-section="currentSection"
      />
      <component v-if="!isLoading" :is="playerDetailComponent"
                 :content-info="contentInfo"
                 :get-toggle-button="getToggleButton"
                 :toggle-info="toggleDetailInfo"
                 :tag-list="getConvertedTagList"
                 :toggle-state="detailInfoToggleState"
                 :click-player-fn="clickPlayer"
      ></component>

      <template v-if="(currentSection === 'vod' || currentSection === 'movie') && noticeList.length > 0">
        <a href="#" v-for="(notice, index) in noticeList" @click.prevent="noticePopupOpen(index)" class="player-notice" :key="'notie_'+index">
          <span class="player-notice-tag">공지사항</span>
          <p class="player-notice-title">{{notice.title}}</p>
        </a>
      </template>
    </div>
    <BottomTabContainer v-if="isBottomLoad" :content-info="contentInfo" :key="$route.fullPath"/>
    <apollo-player-notice-popup v-if="!isLoading && isNoticePopup" :notice-list="noticeList"></apollo-player-notice-popup>
  </div>
</template>

<script>
import MainHeader from '@/components/header/template/MainHeader'
import {
  verifyAdultContentProtectionState,
  ClipInfoService,
  LiveInfoService,
  MovieInfoService,
  VodInfoService
} from '@/common/api/api.service'
import { topTagList } from '@/common/directives'
import _, { get, remove, defaultTo } from 'lodash'
import { mapGetters, mapMutations } from 'vuex'
import CellList from '@/components/section/template/cell/CellList'
import AllContentList from '@/components/play/bottom-tab/AllContentList'
import BottomTabContainer from '@/components/play/bottom-tab/BottomTabContainer'
import EventOpen from '@/assets/svg/common/ic_open_b.svg'
import EventClose from '@/assets/svg/common/ic_closd_b.svg'
import Player from '@/assets/svg/common/ic-player-play-l.svg'
import utils from '@/common/util/utils'
import NextButtonWhite from '@/assets/svg/common/ic-next-s-w.svg'
import BackButton from '@/assets/svg/common/ic_gnb_back_w.svg'
import {
  ALREADY_ADULT_VERIFIED,
  HIDDEN_CONTENT_REDIRECT_TO_HOME,
  NEED_LOGIN, NEED_PIN_CODE,
  NEED_VERIFIED,
  NOT_A_ADULT_CONTENT
} from '@/common/constant'
import { EventBus } from '@/components/eventbus/EventBus'
import LnbWrapper from '@/components/lnb/LnbWrapper'
import { parseUrl, stringify } from 'query-string'
import { popupInsideThePlayerOpen, popupInsideThePlayerClose, enableBodyScroll } from '@/common/util/ui.utils'
import {
  PATH_NAME_APOLLO_ADULTVERIFY_UNLOCK,
  PATH_NAME_GLOBAL,
  PATH_NAME_NOT_FOUND,
  PATH_NAME_VOD
} from '@/common/router.const'
import MobilePlayer from '@/components/play/MobilePlayer'
import playerPage from '@/components/play/mixins/player.page.mixin'
import { fixedToolBar } from '@/common/utils/apollo.interface'
import ApolloPlayerNoticePopup from '@/components/play/apollo/ApolloPlayerNoticePopup'

export default {
  name: 'ApolloPlayerDetail',
  mixins: [
    playerPage
  ],
  components: {
    ApolloPlayerNoticePopup,
    MobilePlayer,
    LnbWrapper,
    MainHeader,
    BottomTabContainer,
    AllContentList,
    CellList,
    MoviePlayerDetailInfo: () => import('@/components/play/apollo/ApolloMoviePlayerDetailInfo'),
    VodPlayerDetailInfo: () => import('@/components/play/apollo/ApolloVodPlayerDetailInfo'),
    LivePlayerDetailInfo: () => import('@/components/play/LivePlayerDetailInfo'),
    ClipPlayerDetailInfo: () => import('@/components/play/ClipPlayerDetailInfo'),
    EventOpen,
    EventClose,
    Player,
    NextButtonWhite,
    BackButton
  },
  directives: {
    topTagList
  },
  data () {
    return {
      isLoaded: false,
      detailInfoToggleState: false,
      eventToggleState: false,
      toggleState: 'open-info-button',
      contentInfo: {},
      count: 0,
      thumbnailInfo: {},
      eventList: [],
      zIndex: 3000,
      currentSection: '',
      isLoading: false,
      isBottomLoad: true,
      eventIndexArr: [],
      noticeList: [],
      isNoticePopup: false,
      hasBeforePageInfo: false
    }
  },
  methods: {
    ...mapMutations(['showSearch', 'showAdultCheck',
      'hideAdultCheck']),
    goBack () {
      if (get(this.$route, ['query', 'referer'], '').indexOf('mypooq') > -1) {
        const GLOBAL_VOD_GENRE_CODE = '09'
        const section = get(this.$route, ['params', 'section'], '')
        const isVod = section === 'vod'
        const isGlobalVod = get(this.contentInfo, 'genrevalue', '') === GLOBAL_VOD_GENRE_CODE
        if (isVod) {
          if (isGlobalVod) {
            this.$router.push({ name: PATH_NAME_GLOBAL })
          } else {
            this.$router.push({ name: PATH_NAME_VOD })
          }
        } else {
          this.$router.push({ name: this.$route.params.section })
        }
      } else {
        this.$router.back()
      }
    },
    getMonthDayString (yearMonthDay) {
      const arr = yearMonthDay.split('-')
      arr[1] = arr[1].charAt(0) === '0' ? arr[1].substr(1, 1) : arr[1]
      arr[2] = arr[2].charAt(0) === '0' ? arr[2].substr(1, 1) : arr[2]
      return `${arr[1]}월 ${arr[2]}일`
    },
    getDayOfWeek (yearMonthDay) {
      let week = ['일', '월', '화', '수', '목', '금', '토']
      return week[new Date(yearMonthDay).getDay()]
    },
    toggleDetailInfo () {
      this.detailInfoToggleState = !this.detailInfoToggleState
    },
    toggleEventInfo (index) {
      if (this.eventIndexArr.indexOf(index) > -1) {
        this.eventIndexArr = remove(this.eventIndexArr, function (n) {
          return n !== index
        })
      } else {
        this.eventIndexArr.push(index)
      }
    },
    removeEvent () {
      EventBus.$off('on-exit')
      EventBus.$off('on-enter')
    },
    async verifiedAdultContent (contentInfo) {
      const targetAge = Number(defaultTo(get(contentInfo, 'targetage', '0'), '0'))
      const res = await utils.common.verifyAdult(targetAge)
      const { query } = parseUrl(this.$route.fullPath)
      delete query.referer
      switch (res) {
        case NOT_A_ADULT_CONTENT:
        case ALREADY_ADULT_VERIFIED:
          this.isBottomLoad = true
          break
        case HIDDEN_CONTENT_REDIRECT_TO_HOME:
          this.$router.replace('/')
          break
        case NEED_LOGIN:
          this.$router.replace(`/login?referer=${this.$route.path}?${stringify(query)}&adult=y`)
          break
        case NEED_PIN_CODE:
          this.$router.replace({
            name: PATH_NAME_APOLLO_ADULTVERIFY_UNLOCK,
            query: {
              referer: this.getBeforeEnterPlayerPath
            },
            params: {
              action: async ({ pincode, resetFn, successFn }) => {
                try {
                  const result = await verifyAdultContentProtectionState(pincode)
                  const { resultcode } = result.data
                  if (resultcode === '200') {
                    successFn()
                  }
                } catch (e) {
                  if (typeof resetFn === 'function') {
                    resetFn()
                  }
                }
              },
              enter: this.$route.fullPath
            }
          })
          break
        case NEED_VERIFIED:
          this.isBottomLoad = false
          EventBus.$once('on-exit', (section, uiCode) => {
            this.$route.query.adult = 'y'
            this.hideAdultCheck()
            this.removeEvent()
            this.isLoading = true
            this.isLoaded = false
            this.$router.back()
          })
          EventBus.$once('on-enter', () => {
            this.isBottomLoad = true
            this.hideAdultCheck()
            this.removeEvent()
          })
          this.showAdultCheck()
          break
      }
    },
    loadContent (route) {
      const section = this.currentSection.toUpperCase()
      if (this.isLoading) return
      this.isLoading = true
      if (section === 'MOVIE') {
        const movieID = route.query.movieid
        MovieInfoService.getMovieMetaInfo({ movieID }, (error) => {
          alert(error.response.data.resultmessage)
          this.routerBack()
        }).then(({ data }) => {
          this.verifiedAdultContent(data)
          this.contentInfo = data
          MovieInfoService.getContentNoticeInfo({ movieId: get(data, 'movieid', '') || movieID }).then(({ data }) => {
            this.noticeList = get(data, 'list', [])
            this.isLoaded = true
            this.isLoading = false
          }).catch(this.routerBack)
        })
        MovieInfoService.getEventBanner({ movieID }).then(({ data }) => {
          this.eventList = get(data, 'list', [])
        })
      } else if (section === 'VOD') {
        const programID = get(route, ['query', 'programid'], '')
        const contentID = get(route, ['query', 'contentid'], '')
        const setVodMetaInfo = (contentID) => {
          VodInfoService.getVodMetaInfo({ contentID }).then(({ data }) => {
            this.verifiedAdultContent(data)
            this.contentInfo = data
            VodInfoService.getContentNoticeInfo({ programID: get(data, 'programid', '') || programID }).then(({ data }) => {
              this.noticeList = get(data, 'list', [])
              this.isLoaded = true
              this.isLoading = false
            }).catch(this.routerBack)
          }).catch(this.routerBack)
        }
        if (contentID !== '') {
          setVodMetaInfo(contentID)
        } else if (programID !== '') {
          VodInfoService.getContentIdByProgramId({ programID }).then(({ data }) => {
            setVodMetaInfo(data.contentid)
          }).catch(this.routerBack)
        } else {
          this.routerBack()
        }
      } else if (section === 'LIVE') {
        const channelID = route.query.channelid
        LiveInfoService.getLiveMetaInfo({ channelID }).then(({ data }) => {
          this.verifiedAdultContent(data)
          this.contentInfo = data
          this.isLoaded = true
          this.isLoading = false
        }).catch(() => {
          this.routerBack()
        })
      } else if (section === 'CLIP') {
        const clipID = route.query.clipid
        ClipInfoService.getClipMetaInfo({ clipID }).then(({ data }) => {
          this.verifiedAdultContent(data)
          this.contentInfo = data
          this.isLoaded = true
          this.isLoading = false
        })
      } else {
        this.$router.push({ name: PATH_NAME_NOT_FOUND })
      }
    },
    goLiveChannel (liveChannel) {
      this.$router.push(`/player/live?channelid=${liveChannel}`)
    },
    addAutoPlayParameter (url) {
      const autoPlayFlag = get(this.$route, 'query.autoplay', 'n')
      return autoPlayFlag.toLowerCase() === 'y' ? url + '&autoplay=y' : url
    },
    // to Player 재생 요청 (재생중, 토스트메세지 등 후처리는 플레이어 안에서)
    clickPlayer () {
      if (window.playerInstance && typeof window.playerInstance.playFromMWeb !== 'undefined') {
        window.playerInstance.playFromMWeb()
      }
    },
    goEventPage (event) {
      this.$router.push(`/event/detail/${event.eventid}`)
    },
    EventToggle (index) {
      return this.eventIndexArr.indexOf(index) > -1
    },
    noticePopupOpen (noticeIndex) {
      const contentId = get(this.$route, 'query.contentid', '')
      const programId = get(this.$route, 'query.programid', '')
      const movieId = get(this.$route, 'query.movieid', '')
      if (this.currentSection === 'vod') {
        this.$router.push(`/apollo/player/vod?${contentId !== '' ? 'contentid=' + contentId
          : 'programid=' + programId}&isNotice=y&noticeIdx=${noticeIndex}`)
      } else {
        this.$router.push(`/apollo/player/movie?movieid=${movieId}&isNotice=y&noticeIdx=${noticeIndex}`)
      }
    },
    routerBack () {
      this.hasBeforePageInfo ? this.$router.back() : this.$router.push('/')
    }
  },
  computed: {
    ...mapGetters(['getBeforeEnterPlayerPath', 'isVisibleAdultCheckView']),
    getToggleButton () {
      let buttonName = ''
      if (!this.detailInfoToggleState) {
        buttonName = 'open-info-button'
      } else if (this.detailInfoToggleState) {
        buttonName = 'close-info-button'
      }
      return buttonName
    },
    playerDetailComponent () {
      return this.currentSection ? `${this.currentSection}-player-detail-info` : null
    },
    getConvertedTagList () {
      const tagCount = get(this.contentInfo, ['tags', 'count'], '')
      if (tagCount === '' || tagCount === '0') return []
      let tagList = get(this.contentInfo, ['tags', 'list'], []).map((tag) => {
        if (typeof tag === 'string') {
          return {
            text: tag,
            value: tag,
            taggroup: 'tag'
          }
        } else {
          if (tag.taggroup === undefined) {
            tag.taggroup = 'tag'
          }
          return tag
        }
      })
      tagList = tagList.filter((tag) => { return tag.text !== '' })
      return tagList
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.hasBeforePageInfo = get(from, 'name', '') !== null
    })
  },
  created () {
    this.currentSection = this.$route.params.section
    // INFO: 추천 목록에서 다른 회차나 프로그램이 19금일경우에 뒤로가기하면 그대로 남아 있는 경우가 있어서 create할때 vuex에 값이 있으면 초기화 한다.
    if (this.isVisibleAdultCheckView) {
      this.hideAdultCheck()
    }
    if (get(this.$route, ['query', 'search'], 'n').toLowerCase() === 'y') {
      this.zIndex = 3001
    }
    this.loadContent(this.$route)
    if (get(this.$route, 'query.isNotice', '') === 'y') {
      popupInsideThePlayerOpen()
      this.isNoticePopup = true
    } else {
      popupInsideThePlayerClose()
      this.isNoticePopup = false
    }
  },
  mounted () {
    enableBodyScroll()
    fixedToolBar(true) // 아폴로 상하단 바 고정
  },
  beforeRouteLeave (to, from, next) {
    if (this.isVisibleAdultCheckView) {
      this.hideAdultCheck()
    }
    next()
  },
  watch: {
    $route (to, from) {
      this.currentSection = get(to, ['params', 'section'], '')
      this.loadContent(to)
    }
  }
}
</script>
<style lang="css" src="@/assets/new-css/apollo.css"></style>
